import { ComponentPropsWithRef, ReactNode } from 'react'
import clsx from 'clsx'

import FormattedText from 'shared/ui/FormattedText'

import { SectionContainer, SectionContent } from '../landings/styles'

import QuestionTags from './QuestionTags'
import { StyledCustomPortableText } from './styles'

import styles from './AboutUsMainSectionWithTags.module.scss'

interface AboutUsMainSectionWithTagsProps {
  header: string
  subheader: string | ReactNode
  content: string | ReactNode
  tags: string[]
}
export default function AboutUsMainSectionWithTags({
  header,
  tags,
  subheader,
  content
}: AboutUsMainSectionWithTagsProps) {
  return (
    <SectionContainer $condensed>
      <SectionContent $top={3} $topMobile={3} $bottom={6} $bottomMobile={2}>
        <h1 className={styles.pageHeader}>
          <FormattedText text={header} />
        </h1>
        <QuestionTags tags={tags} />

        <SectionCenterHeaderDiv>{subheader}</SectionCenterHeaderDiv>
        <StyledCustomPortableText style={{ textAlign: 'center' }}>
          {content}
        </StyledCustomPortableText>
      </SectionContent>
    </SectionContainer>
  )
}

export const SectionCenterHeaderDiv = ({
  className,
  ...props
}: ComponentPropsWithRef<'div'>) => (
  <div className={clsx(styles.sectionCenterHeaderDiv, className)} {...props} />
)
